'use strict';

export class BaseFilter {
	constructor({ i18n, configService, filterOperatorsFactory }) {
		Object.assign(this, { i18n, configService, filterOperatorsFactory });
		this.allOperators = this.filterOperatorsFactory.operators;
	}

	init(column) {
		Object.defineProperty(this, '_column', { enumerable: false, value: column });
		this.operatorOnForm = this.operators[0].value;
		this.setDefault();
		this.value = this.getNewValue();
		this.operator = this.operatorOnForm;
	}

	getOperatorTitle() {
		return this.operators.filter((operator) => operator.value === this.operator)[0].name;
	}

	getOperatorLabel() {
		const operator = this.operators.filter((operator) => operator.value === this.operator)[0];
		return operator.label || operator.name;
	}

	setDefault() {
		this.value = undefined;
	}

	getNewValue() {
		return [this.inlineValue || ''];
	}

	updateTitle() {
		this.title = this.value || '';
	}

	clearFilter() {
		this.setDefault();
		this.applyFilter(true);
	}

	applyFilter(urgent) {
		if (!this.isValueChanged() && this.operator === this.operatorOnForm) {
			return false;
		}
		this.value = this.getNewValue();
		this.operator = this.operatorOnForm;
		this.operatorTitle = this.getOperatorTitle();
		this.operatorLabel = this.getOperatorLabel();
		this.updateTitle();
		if (typeof this.changeHandler === 'function') {
			this.changeHandler(this, urgent);
		}
		return true;
	}

	isValueChanged() {
		return !angular.equals(this.getNewValue(), this.value);
	}

	isFormValid() {
		return true;
	}

	hasValue() {
		return Boolean(this.value);
	}

	addChangeHandler(handler) {
		this.changeHandler = handler;
	}
}
